export const Field = ({ label, required, error, hint, children }) => (
  <div className="flex flex-col">
    <label className="label-mono text-[#52525B] mb-2">
      {label}{required && " *"}
    </label>
    {children}
    {hint && !error && <p className="mt-1.5 text-xs text-[#52525B]">{hint}</p>}
    {error && <p className="mt-1.5 text-xs font-medium text-red-500">{error}</p>}
  </div>
);

const baseCls = (invalid) =>
  `w-full rounded-xl border bg-white px-4 py-3.5 text-sm text-[#0A1628] placeholder-black/30 outline-none transition-all duration-200 ${
    invalid
      ? "border-red-400 focus:border-red-500"
      : "border-black/10 focus:border-[#007AFF] focus:shadow-[0_0_0_4px_rgba(0,122,255,0.12)]"
  }`;

export const TextInput = ({ value, onChange, placeholder, type = "text", invalid, inputMode, ...rest }) => (
  <input
    type={type}
    inputMode={inputMode}
    value={value}
    onChange={onChange}
    placeholder={placeholder}
    className={baseCls(invalid)}
    {...rest}
  />
);

export const SelectInput = ({ value, onChange, options, invalid, placeholder, ...rest }) => (
  <div className="relative">
    <select
      value={value}
      onChange={onChange}
      className={`${baseCls(invalid)} appearance-none pr-10 ${value ? "" : "text-black/30"}`}
      {...rest}
    >
      <option value="" disabled>{placeholder || "Select…"}</option>
      {options.map((o) => (
        <option key={o} value={o}>{o}</option>
      ))}
    </select>
    <svg className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 w-4 h-4 text-[#52525B]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M6 9l6 6 6-6" />
    </svg>
  </div>
);

export const TextArea = ({ value, onChange, placeholder, invalid, rows = 4, ...rest }) => (
  <textarea
    rows={rows}
    value={value}
    onChange={onChange}
    placeholder={placeholder}
    className={`${baseCls(invalid)} resize-none`}
    {...rest}
  />
);

export const RadioPills = ({ value, onChange, options, testid }) => (
  <div className="flex flex-wrap gap-2">
    {options.map((o) => (
      <button
        key={o.value}
        type="button"
        data-testid={`${testid}-${o.value}`}
        onClick={() => onChange(o.value)}
        className={`rounded-full px-5 py-2.5 text-sm font-semibold transition-all duration-300 ${
          value === o.value
            ? "bg-[#0A1628] text-white shadow-[0_6px_20px_rgba(10,22,40,0.2)]"
            : "border border-black/10 text-[#52525B] hover:border-black/25"
        }`}
      >
        {o.label}
      </button>
    ))}
  </div>
);

export const ChipMulti = ({ values, onToggle, options, testid }) => (
  <div className="flex flex-wrap gap-2">
    {options.map((o) => {
      const on = values.includes(o.value);
      return (
        <button
          key={o.value}
          type="button"
          data-testid={`${testid}-${o.value}`}
          onClick={() => onToggle(o.value)}
          className={`rounded-full px-4 py-2.5 text-sm font-semibold transition-all duration-300 ${
            on
              ? "bg-[#007AFF] text-white shadow-[0_6px_20px_rgba(0,122,255,0.3)]"
              : "border border-black/10 text-[#52525B] hover:border-[#007AFF]/50 hover:text-[#007AFF]"
          }`}
        >
          {o.label}
        </button>
      );
    })}
  </div>
);
